export const BODY = "Public Sans";
export const TITLE = "Public Sans";

export const REGULAR = "400";
export const SEMI_BOLD = "600";
export const BOLD = "700";

export const INPUT_LABEL_SIZE = "14px";
export const FONT_SIZE_BASE = "14px";
export const FONT_SIZE_MEDIUM = "16px";

export const LINE_HEIGHT_LARGE = "24px";
